import { useMemo } from 'react';
import { VcaTriggerLandingPage } from '../shared/VcaTriggerLandingPage';
import {
    dynamicRetentionNotesPreset,
    midTxRefinementNotesPreset,
    refinementNotesPreset,
    refinementV2NotesPreset
} from '../shared/vcaNoteTemplates';
import type { ActionRunnerProps } from '../../types';
import type { VcaTriggerConfig } from '../shared/vca-trigger-config';
import { useRefinementTarget } from './useRefinementTarget';

const REFINEMENT_CONFIG: VcaTriggerConfig = {
    notesPresets: [
        refinementNotesPreset,
        refinementV2NotesPreset,
        midTxRefinementNotesPreset,
        dynamicRetentionNotesPreset
    ],
    singular: 'refinement',
    plural: 'refinements',
    eventType: 'refinement_trigger',
    apiPath: 'refinement',
    workflowAction: 'refinement-needed',
    targetCaseStatus: 'Ready for refinement',
    targetActionRequired: 'Review for refinement',
    targetInternalCaseStatus: 'Ref - 1. Ready for refinement',
    notesPanelTitle: 'Refinement notes',
    checkStep: {
        kind: 'clinicMessages',
        warning: (
            <>
                Before triggering a refinement, verify there are no recent messages from the clinic
                under <span className="font-semibold">"Conversations"</span>.
            </>
        )
    }
};

// The static Ref-1 target stays in place while the backend-resolved one loads or if it fails.
function RefinementLandingPage(
    props: ActionRunnerProps & { onSubmitted?: (landedOn: string) => void }
) {
    const target = useRefinementTarget(props.patientId);
    const config = useMemo<VcaTriggerConfig>(
        () =>
            target
                ? {
                      ...REFINEMENT_CONFIG,
                      targetCaseStatus: target.externalStatus,
                      targetActionRequired: target.actionRequired,
                      targetActionBy: target.actionBy,
                      targetInternalCaseStatus: target.internalStatus
                  }
                : REFINEMENT_CONFIG,
        [target]
    );
    return <VcaTriggerLandingPage {...props} config={config} />;
}

export { RefinementLandingPage };
